<template lang="pug">
.search-input-wrapper
  InputText.search-input(
    v-model="keyword" 
    :placeholder="placeholder" 
    :disabled="loading"
    :type="type"
    @keyup="$emit('keyup', $event)")
  Button.search-button(@click="search()" :label="submitLabel" :loading="loading")
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { computed } from "vue";

import InputText from "primevue/inputtext";
import Button from "primevue/button";

export default defineComponent({
  components: {
    InputText,
    Button,
  },
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    submitLabel: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
      default: undefined,
    },
    loading: Boolean,
    type: {
      type: String,
      default: undefined,
    },
  },
  emits: ["update:modelValue", "search", "keyup"],
  setup(props, { emit }) {
    const keyword = computed({
      get() {
        return props.modelValue;
      },
      set(val?: string) {
        emit("update:modelValue", val);
      },
    });

    function search() {
      emit("search", keyword.value);
    }

    return {
      keyword,
      search,
    };
  },
});
</script>
<style scoped lang="scss">
.search-input-wrapper {
  display: flex;
  max-width: 26rem;

  .search-input {
    flex-grow: 1;
  }

  .search-button {
    cursor: pointer;
  }
}

@media screen and (max-width: 720px) {
  .search-input-wrapper {
    width: 100%;
  }
}
</style>
